module.exports = __webpack_public_path__ + "static/media/YF86_01.bd4c0aa8.jpg";